import { OptionDropdownSelect } from "../../create-request/models/OptionDropdownSelect";
import { USCountryFullName } from "./Constants";


export function CountryDescriptionFromCode (countryCode: string, countryList?: OptionDropdownSelect[]): string {
    if (countryCode === 'US') { //avoid country lookup if country is US, as this will be the case most of the time
        return USCountryFullName;
    }

    if (countryList) {
        let value = countryList.find(c => c.value === countryCode);
        if (value !== undefined) {
            return value.name;
        }
    }
    return countryCode;
}
